export function filterFacetAutogenerateKeys(keys: string[], query: string): string[] {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return keys;
  return keys.filter((key) => key.toLowerCase().includes(trimmed));
}
